import axios from "axios";

export const getEducationDegrees = callback => {
  var promise = axios({
    method: "get",
    url: "/api/education_degrees"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
